export default {
  // #region Danh mục

  // #region Tài khoản
  AutoBusiness: 'di_auto_business', // Định khoản tự động
  AccountParallelRule: 'di_account_parallel_rule', // quy tắc hạch toán đồng thời
  AccountTransfer: 'di_account_transfer', // danh mục tk kết chuyển
  AccountBalance: 'di_account_balance', // số dư tài khoản
  SystemAccount: 'di_account', // TK hệ thống
  DefaultAccount: 'ref_type', // danh mục tk ngầm định
  // #endregion

  // #region Mục lục ngân sách
  BudgetProvide: 'di_budget_provide',
  BudgetSourceProperty: 'di_budget_source_property',
  // #endregion

  // #region  Danh mục Khác
  Activity: 'di_activity',
  FundStructure: 'di_fund_structure',

  ProjectBudget: 'di_project_budget_detail',

  // Danh mục vật tư hàng hóa
  InventoryItem: 'di_inventory_item',

  // Danh mục công cụ dụng cụ
  InventoryItemTools: 'di_inventory_item_tool',

  // Danh mục Mã thống kê
  Statistic: 'di_statistic',
  // Danh mục Mã thống kê
  BankInfo: 'di_bank_info',

  // Danh mục Thôn xóm
  Hamlet: 'di_hamlet',
  // Danh mục đối tượng
  AccountingObject: 'di_accounting_object',
  // Danh mục Cán bộ
  AccountingObjectCb: 'di_accounting_object_cb',
  // Danh mục Tài sản cố định
  FixedAsset: 'di_fixed_asset',
  // Danh mục chương trình mục tiêu, dự án
  Project: 'di_project',
  // Danh mục nguồn kinh phí
  BudgetSource: 'di_budget_source',
  // Danh mục CTMTDA
  Project: 'di_project',

  // cấu hình chỉ tiêu công thức TODO:
  DiPlanActivityFormula: 'di_plan_activity_formula',
  //Dự toán thu MLNS
  BuPlanReceiptMLNS: 'bu_plan_receipt_budget',
  //Dự toán chi MLNS
  BuPlanExpanseMLNS: 'bu_plan_expense_budget',

  BuPlanExpanseNDKT: 'bu_plan_expense_activity',
  // #endregion

  // #region Chứng từ

  // Chi tiền gửi
  BADeposit: '30',
  // Phiếu rút tiền kho bạc
  BUTreasuryWithdrawal: '31',
  // Chuyển tiền nội bộ
  BAInternalTransfer: '32',
  // Điều chỉnh kinh phí chi
  CAAdjustPayment: '40',
  CAAdjustReceipt: '41',
  // Chuyển khoản kho bạc
  BUTransfer: '34',
  // Chuyển kho
  InventoryTransfer: '64',
  // Phiếu ghi tăng TSCĐ
  FixedAssetIncrement: '70',
  // Phiếu ghi giảm TSCĐ
  FixedAssetDecrement: '71',
  // Phiếu điều chỉnh TSCĐ
  FixedAssetAdjustment: '72',
  // Khấu hao TSCĐ
  FixedAssetDepreciation: '73',
  // Phiếu ghi tăng CCDC
  ToolIncrement: '74',
  // Phiếu ghi giảm CCDC
  ToolDecrement: '75',
  // Phiếu điều chuyển CCDC
  ToolTransfer: '77',
  // Phiếu thu
  CAReceipt: '20',
  // Phiếu chi
  CAPayment: '21',
  // Phiếu kết chuyển tài khoản
  SUAccountTransfer: '101',
  // bảng kê ghi thu-ghi chi
  BUReceiptExpense: '103',
  // kế hoạch xdcb
  ConstructionBudget: '303',

  // Chứng từ trả lương, bảo hiểm
  SalaryVoucher: '123',
  // SalaryVoucherTreasury: '124',
  // Chứng từ ghi đồng thời
  ParallelVoucher: '106',
  // Kết chuyển thu, chi ngân sách xã
  TranferReceiptClear: '130',
  // Kết chuyển chi ngân sách
  TranferPaymentClear: '131',
  // Kết chuyển cuối năm
  TranferClosing: '132',
  // Kết chuyển kết dư sang thu ngân sách xã
  TransferBudgetBalance: '133',
  // Kết chuyển hoạt động sự nghiệp
  TransferActivity: '134',
  // Quyết toán dự toán chi ngân sách cuối năm
  TransferBegining: '135',
  // Kết chuyển thu, chi ngân sách trong thời gian chỉnh lý
  TranferReceiptClearInMonth13: '136',
  // Kết chuyển chi ngân sách trong thời gian chỉnh lý
  TranferPaymentClearInMonth13: '137',
  // Kết chuyển kết dư ngân sách xã
  TransferBalance: '138',
  // Kết chuyển kết dư ngân sách xã trong thời gian chỉnh lý
  TransferBalanceInMonth13: '139',

  BUPlanReceiptAddMLNS: '153',
  BUPlanReceiptAddMLNSSupplement: '152',

  // Tiền gửi - Chi tiền gửi
  CashDeposit: '30',
  // Tiền gửi - Thu tiền gửi
  BAWithDraw: '33',
  // DTNS - Dự toán giữ lại
  BUBudgetReserve: '44',
  // DTNS - Đề nghị cam kết chi
  BUCommitmentRequest: '42',
  // DTNS - Điều chỉnh cam kết chi
  BUCommitmentAdjustment: '43',
  // Nhận dự toán đầu năm
  BUReceiveBudgetPlan: '154',
  // Nhận dự toán bổ sung
  BUReceiveBudgetPlanSupplement: '155',
  // Điều chỉnh dự toán
  BUPlanAdjustment: '156',
  // Chuyển khoản kho bạc vào tài khoản tiền gửi
  BUTransferDeposit: '165',
  // Nhập mua bằng tiền mặt
  InventoryInwardCash: '62',
  // Nhập mua bằng tiền gửi
  InventoryInwardDeposit: '63',
  // Nhập khác
  INInward: '60',
  // Phiếu xuất kho
  INOutward: '61',
  // Chứng từ nghiệp vụ khác
  SUGeneralVoucher: '100',

  // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherIncreament: '410',
  // Điều chỉnh TSCĐ từ QLTS.VN
  FAVoucherAdjustment: '411',
  // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDepreciate: '412',
  // Hao mòn TSCĐ từ QLTS.VN
  FAVoucherDepreciation: '413',
  // Ghi giảm TSCĐ từ QLTS.VN
  FAVoucherDecrement: '414',

  // hủy dự toán
  BUPlanCancel: '157',
  // bảng kê thanh toán tạm ứng
  BUAdvancePayment: '104',
  // Dự toán chi theo MLNS
  BUPlanExpenseByBudget: '150',
  // điều chỉnh kinh phí
  BUExpenseWithdrawAdjustment: '652',
  // Số dư đầu tài khoản khác
  OpeningAccount: '109',
  // Số dư ban đầu đối tượng
  OpeningAccountingObject: '112',
  // Điều chỉnh Dự toán thu theo MLNS
  BUPlanReceiptAdjustMLNS: '321',
  // bảng kê chứng từ thực chi
  BUAdvanceExpence: '105',
  // Hạch toán chi phí lương, BH, KPCĐ
  GlPayrollExpense: '81',
  // #endregion

  // #region
  // Khác
  PlanActivityFormula: 'di_plan_activity_formula',
  // nhập số dư đầu kỳ
  OpeningAccountEntry: 'opening_account_entry',
  // Số dư đầu kỳ vật tư, công cụ dụng cụ
  OpeningInventoryEntry: 'opening_inventory_entry',
  // #endregion
};
